import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { useAuth } from "../context/AuthContext";

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await supabase.auth.signOut();
    navigate("/login");
  }

  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: 24 }}>
      <h1>Dashboard</h1>
      <p>Signed in as: {user?.email}</p>

      <div style={{ display: "flex", gap: 12, marginTop: 20 }}>
        <Link to="/accounts">
          <button>Go to Portfolio Accounts</button>
        </Link>

        <button onClick={handleLogout}>Log Out</button>
      </div>
    </div>
  );
}